const teamMembers = [
  // Leadership
  // {
  //   name: "Md Shafiul Alam",
  //   designation: "Chairman",
  //   image: "",
  //   category: "top-management",
  // },
  {
    name: "Al Imran",
    designation: "Managing Director & Architect",
    image: "",
    category: "top-management",
  },
  {
    name: "Nazma Akter",
    designation: "Director, Business and Sales",
    image: "",
    category: "top-management",
  },

  // Architecture & Engineering
  {
    name: "Md. Asaduzzaman",
    designation: "Project Manager – Civil",
    image: "",
    category: "architect-engineer",
  },
  {
    name: "Tausif Hasan",
    designation: "Architect",
    image: "",
    category: "architect-engineer",
  },
  {
    name: "Munthasir Ahmed",
    designation: "Architect & Design Coordinator",
    image: "",
    category: "architect-engineer",
  },
  {
    name: "Shahriar Iqbal",
    designation: "Project Engineer",
    image: "",
    category: "architect-engineer",
  },
  {
    name: "Sohanuzzaman Shanto",
    designation: "Site Engineer – Civil",
    image: "",
    category: "architect-engineer",
  },
  {
    name: "Md. Shazib",
    designation: "Procurement Engineer – Civil",
    image: "",
    category: "architect-engineer",
  },
  {
    name: "Ramjanul Islam Sagor",
    designation: "Site Engineer – Civil",
    image: "",
    category: "architect-engineer",
  },
  {
    name: "Md Sadikur Rahman",
    designation: "Site Engineer – Civil",
    image: "",
    category: "architect-engineer",
  },

  // Management & Sales
  {
    name: "Md. Rafique Hossain",
    designation: "HR Manager",
    image: "",
    category: "management",
  },
  {
    name: "Md. Istiaqe Ahmed",
    designation: "Accounts Officer",
    image: "",
    category: "management",
  },
  {
    name: "Sumaya Tabassum",
    designation: "Graphics Designer",
    image: "",
    category: "management",
  },
  {
    name: "Intisha Tasnim",
    designation: "Sales Executive",
    image: "",
    category: "management",
  },
  {
    name: "Onnesha Ishra",
    designation: "Sales Executive",
    image: "",
    category: "management",
  },
];

export default teamMembers;
